import {Box} from "@mui/material";
import {PuiMainContainer} from "@portnet/ui";
import React from "react";
import {useSelector} from "react-redux";
import {Outlet} from "react-router-dom";
import useCurrentScreenSize from "../../hooks/useCurrentScreenSize";
import AppMenu from "../menu/AppMenu";
import AppToolbar from "../menu/AppToolbar";
import {AxiosInterceptor} from "./AxiosInterceptor";

const TOOLBAR_HEIGHT = "64px";

const menuWidthByScreenSize = {
  xs: {
    opened: "250px",
    closed: "0",
  },
  sm: {
    opened: "320px",
    closed: "52px",
  },
  md: {
    opened: "320px",
    closed: "52px",
  },
  lg: {
    opened: "320px",
    closed: "52px",
  },
  xl: {
    opened: "320px",
    closed: "52px",
  },
};

const AppMainContainer = () => {
  const [menuWidth, setMenuWidth] = React.useState(0);
  const currentScreenSize = useCurrentScreenSize();
  const isLogged = useSelector((state) => Boolean(state.auth.login.user));
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [runTour, setRunTour] = React.useState(true);

  const menuIconClickHandler = () => {
    setIsMenuOpen((oldIsMenuOpen) => !oldIsMenuOpen);
  };

  const handleMenuIconHover = (e) => {
    if (e.type === "mouseenter") {
      setIsMenuOpen(true); // Open menu on hover
    }/* else if (e.type === "mouseleave") {
      setIsMenuOpen(false); // Close menu when mouse leaves
    }*/
  };
  // This function is called when starting or stopping the tour
  const startTour = (start) => {
    setRunTour(start);
  };

  const handleMouseEnter = () => {
    setIsMenuOpen(true);  // Open the menu when hovering
  };

  const handleMouseLeave = () => {
    setIsMenuOpen(false); // Close the menu when mouse leaves the hover area
  };

  React.useEffect(() => {
    setMenuWidth(menuWidthByScreenSize[currentScreenSize]);
  }, [currentScreenSize, isMenuOpen]);

  return (
      <>
        {isLogged ? (
            <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
              <AppToolbar
                  onMenuIconClick={menuIconClickHandler}
                  onMenuIconHover={handleMenuIconHover} // Pass hover handler to toolbar
                  height={TOOLBAR_HEIGHT}
              />
              <Box sx={{ display: "flex", flexGrow: 1, paddingTop: TOOLBAR_HEIGHT }}>
                <Box>
                  <AppMenu
                      width={menuWidth[isMenuOpen ? "opened" : "closed"]}
                      sx={{ height: `calc(100vh - ${TOOLBAR_HEIGHT})`, overflowY: "auto" }}
                      open={isMenuOpen}
                      toggleIsMenuOpen={menuIconClickHandler}
                      runTour={runTour}
                      startTour={startTour} // Pass startTour to AppMenu for tour control
                  />
                </Box>

                {/* Main content container */}
                <PuiMainContainer
                    sx={{
                      marginLeft: menuWidth.closed,
                      flexGrow: 1,
                    }}
                >
                  <AxiosInterceptor>
                    <Outlet />
                  </AxiosInterceptor>
                </PuiMainContainer>
              </Box>
            </Box>
        ) : (
            <AxiosInterceptor>
              <AppToolbar
                  onMenuIconClick={menuIconClickHandler}
                  height={TOOLBAR_HEIGHT}
              />
              <PuiMainContainer>
                <Outlet />
              </PuiMainContainer>
            </AxiosInterceptor>
        )}
      </>
  );
};

export default AppMainContainer;


